import React from "react";
import config from "../../config";
import Navigation from "../Navigation";
import Footer from "../Footer";
import ContactOptionsModal from "../ContactOptionsModal";
import ScheduleTourModal from "../ScheduleTourModal";
import AccessibilityModal from "../AccessibilityModal";
import "./styles.scss";

const ROUTER_ROOT_RE = new RegExp("^" + config.routerRoot);
const BROKER_RE = /broker\/?/;
const AVAIL_RE = /availability\/?/;

export default class GlobalLayout extends React.Component {
  constructor(props) {
    super(props);

    // handle a redirect from the old contact page
    const fromContact = Boolean(
      props.location && props.location.state && props.location.state.fromContact
    );

    // Make it possible to have the schedule tour modal open on page load
    const showScheduleTour = Boolean(
      props.location && typeof props.location.query.bookTour !== "undefined"
    );
    // this.bannerText = [
    //   "$1,000 Moving Credit: Sign in December, Move through March",
    // ];
    this.bannerText = [
      "Happy HAULidays! Receive a $500 Moving Credit when you sign a lease any time before 12/31/24.",
    ];
    // this.secondBannerText = [
    //   "NOW OFFERING IN-PERSON & VIRTUAL TOURS, 7 DAYS A WEEK",
    // ];

    this.state = {
      showContactOptionsModal: fromContact || false,
      showTermsAndConditionsModal: false,
      showAccessibilityModal: false,
      showScheduleTourModal: showScheduleTour || false,
      currentBannerIndex: 0,
      currentListing: {},
    };

    this.openContact = this.openContact.bind(this);
    this.closeContact = this.closeContact.bind(this);
    this.openScheduleTour = this.openScheduleTour.bind(this);
    this.closeScheduleTour = this.closeScheduleTour.bind(this);
    this.openTerms = this.openTerms.bind(this);
    this.closeTerms = this.closeTerms.bind(this);
    this.openAccessibility = this.openAccessibility.bind(this);
    this.closeAccessibility = this.closeAccessibility.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.rotateBanner = this.rotateBanner.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    setInterval(this.rotateBanner, 4000);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  rotateBanner() {
    let newIndex =
      this.state.currentBannerIndex === this.bannerText.length - 1
        ? 0
        : this.state.currentBannerIndex + 1;
    this.setState({ fadeIn: true, currentBannerIndex: newIndex });
    setTimeout(() => {
      this.setState({ fadeIn: false });
    }, 2000);
  }

  handleScroll() {
    let navbar = document.querySelector(".global-layout__navigation"),
      reg = new RegExp(
        "(\\s|^)" + "global-layout__navigation--top" + "(\\s|$)"
      ),
      headerHeight = navbar.offsetHeight;

    if (
      document.body.scrollTop > headerHeight ||
      document.documentElement.scrollTop > headerHeight
    ) {
      if (!navbar.className.includes("global-layout__navigation--top"))
        navbar.className += " global-layout__navigation--top";
    } else {
      navbar.className = navbar.className.replace(reg, " ");
    }
  }

  closeContact() {
    // TODO: refactor. This is a fragile, incomplete way to handle child modals.
    // See commit b56e11b405d1e26493b52de56885cb09071bbc3e for an explanation.

    // If a "child" modal (i.e., the terms and conditions modal or the
    // schedule a tour modal) is open, we can't close the contact modal until
    // its closed. So, this check is needed because a click outside the
    // contact modal (e.g. on the TOC modal's close button) will try to close it,
    // and that could be incorrect. This check simulates the idea that the TOC
    // is an "active", "child" modal, and that we can't interact with the parent
    // until the child is addressed.
    if (
      this.state.showTermsAndConditionsModal ||
      this.state.showScheduleTourModal
    )
      return;

    this.setState({ showContactOptionsModal: false });
    document
      .querySelector(".global-layout")
      .classList.remove("global-layout--fixed");
  }

  openContact() {
    const listingId = new URLSearchParams(window.location.search).get("id");
    const currentListing =
      this.props.listings && this.props.listings[listingId];
    this.setState({ showContactOptionsModal: true, currentListing });
    document
      .querySelector(".global-layout")
      .classList.add("global-layout--fixed");
  }

  openScheduleTour() {
    this.setState({ showScheduleTourModal: true });
    document
      .querySelector(".global-layout")
      .classList.add("global-layout--fixed");
  }

  closeScheduleTour() {
    this.setState({ showScheduleTourModal: false });
    document
      .querySelector(".global-layout")
      .classList.remove("global-layout--fixed");
  }

  openTerms() {
    this.setState({ showTermsAndConditionsModal: true });
    document
      .querySelector(".global-layout")
      .classList.add("global-layout--fixed");
  }

  closeTerms() {
    this.setState({ showTermsAndConditionsModal: false });
    document
      .querySelector(".global-layout")
      .classList.remove("global-layout--fixed");
  }

  openAccessibility() {
    this.setState({ showAccessibilityModal: true });
    document
      .querySelector(".global-layout")
      .classList.add("global-layout--fixed");
  }

  closeAccessibility() {
    this.setState({ showAccessibilityModal: false });
    document
      .querySelector(".global-layout")
      .classList.remove("global-layout--fixed");
  }

  componentWillReceiveProps(nextProps) {
    // handle a redirect from the old contact page
    try {
      if (nextProps.location.state.fromContact) {
        this.openContact();
      }
    } catch (e) {}
  }

  render() {
    const getPath = () => {
      let new_string =
        this.props.location &&
        this.props.location.pathname
          .replace(ROUTER_ROOT_RE, "")
          .replace(BROKER_RE, "");
      if (new_string.includes("availability")) {
        let new_string_array =
          this.props.location &&
          this.props.location.pathname.replace(ROUTER_ROOT_RE, "").split("/");
        new_string = new_string
          .replace("/" + new_string_array[1], "")
          .replace(new_string_array[1], "");
      }
      return new_string;
    };

    const pageClassName = getPath() || "home";

    return (
      <div>
        <a tabIndex="0" className="skip-main" href="#main">
          {" "}
          Skip to main content
        </a>
        <div className={`global-layout app ${pageClassName}`}>
          {/* <div className="global-layout__banner">
            <a href="/availability">
              <span>{this.bannerText[this.state.currentBannerIndex]}</span>
            </a>
          </div> */}

          {/* <div className="global-layout__banner second">
            <a href="/availability">
              <span>{this.secondBannerText[0]}</span>
            </a>
          </div> */}
          <div className="global-layout__header--mobile">
            <span>
              Contact Us: <a href="tel:7182220066">(718)-222-0066</a>
            </span>
          </div>
          <div
            className={
              this.state.showContactOptionsModal
                ? "global-layout__navigation global-layout__navigation--top"
                : "global-layout__navigation"
            }
          >
            <Navigation
              openContactModal={this.openContact}
              closeContactModal={this.closeContact}
              isContactModalActive={this.state.showContactOptionsModal}
              openScheduleTourModal={this.openScheduleTour}
              closeScheduleTourModal={this.closeScheduleTour}
            />
          </div>
          <div className={`global-layout__body page ${pageClassName}`}>
            {React.Children.only(
              React.cloneElement(this.props.children, {
                openContactModal: this.openContact,
                closeContactModal: this.closeContact,
                openTermsAndConditionsModal: this.openTerms,
                closeTermsAndConditionsModal: this.closeTerms,
                openAccessibilityModal: this.openAccessibility,
                closeAccessibilityModal: this.closeAccessibility,
                isContactModalActive: this.state.showContactOptionsModal,
                openScheduleTourModal: this.openScheduleTour,
                closeScheduleTourModal: this.closeScheduleTour,
                utmParams: this.props.utmParams,
                listings: this.props.listings,
                baseUrl: this.props.baseUrl,
                syncListings: this.props.syncListings,
                toggleListingSaved: this.props.toggleListingSaved,
              })
            )}

            <ContactOptionsModal
              isOpened={this.state.showContactOptionsModal}
              onClose={this.closeContact}
              onOpenTerms={this.openTerms}
              onCloseTerms={this.closeTerms}
              utmParams={this.props.utmParams}
              showTerms={this.state.showTermsAndConditionsModal}
              onOpenScheduleTour={this.openScheduleTour}
              currentListing={this.state.currentListing}
            />

            <ScheduleTourModal
              isOpened={this.state.showScheduleTourModal}
              utmParams={this.props.utmParams}
              onClose={this.closeScheduleTour}
            />

            <AccessibilityModal
              isOpened={this.state.showAccessibilityModal}
              onClose={this.closeAccessibility}
            />
          </div>
          <div className="global-layout__footer">
            <Footer
              openContactModal={this.openContact}
              openTermsAndConditionsModal={this.openTerms}
              openAccessibilityModal={this.openAccessibility}
              isContactModalActive={this.state.showContactOptionsModal}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/GlobalLayout/index.js